/* eslint-disable */
import { memo, forwardRef } from "react";

// phone.tsx
export const PhoneIcon = memo(
  forwardRef(function PhoneIcon(
    { size = 24, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M3.84127 4.38875C3.84127 4.38875 3.80381 4.42934 3.75464 4.47773C3.56575 4.66115 3.17472 5.04281 3.17082 5.84127C3.16458 6.95817 3.89903 9.03196 7.43549 12.5677C10.9556 16.0862 13.0262 16.8292 14.1455 16.8292H14.1619C14.9603 16.8253 15.3412 16.4335 15.5254 16.2454C15.5816 16.1876 15.6269 16.1455 15.6589 16.119C16.4363 15.3369 16.8343 14.7546 16.8304 14.3816C16.825 14.0007 16.3512 13.5503 15.6964 12.9274C15.4879 12.7292 15.2616 12.5138 15.0227 12.2749C14.4039 11.6576 14.0971 11.7629 13.4227 12.0002C12.4901 12.3273 11.21 12.7722 9.22128 10.7826C7.22944 8.79235 7.6751 7.51388 8.00135 6.58118C8.23707 5.90683 8.34477 5.59931 7.72506 4.97959C7.48232 4.73764 7.26456 4.50817 7.06397 4.29743C6.44503 3.64649 5.99858 3.17585 5.62004 3.17039H5.61379C5.23993 3.17039 4.65924 3.57 3.83737 4.39187C3.83971 4.38953 3.84127 4.38875 3.84127 4.38875ZM14.1463 18C12.2013 18 9.66539 16.4515 6.60816 13.3957C3.53922 10.3276 1.98836 7.78394 2.00007 5.83502C2.00709 4.54719 2.68223 3.88767 2.93589 3.64025C2.94916 3.62386 2.99443 3.57937 3.01004 3.56376C4.12928 2.44374 4.88402 1.99105 5.63487 1.99963C6.50669 2.01134 7.12719 2.66384 7.91238 3.49039C8.10672 3.69488 8.31746 3.91733 8.55239 4.15148C9.69192 5.29101 9.36723 6.22059 9.10655 6.96675C8.82244 7.78082 8.57658 8.48327 10.0486 9.9553C11.5222 11.4273 12.2247 11.1815 13.0356 10.895C13.7826 10.6343 14.7098 10.3081 15.8509 11.4476C16.0819 11.6786 16.3012 11.8871 16.5034 12.0798C17.3339 12.8689 17.9895 13.4925 18.0004 14.3667C18.0098 15.1121 17.5571 15.8715 16.4394 16.99L15.9446 16.6544L16.3629 17.0634C16.1155 17.317 15.4567 17.9929 14.1681 18H14.1463Z"
          fill={color}
        />
      </svg>
    );
  }),
);
